import heroBanner from "../../assets/images/pages/florida-driving-test.jpg";
import permitImage from "../../assets/images/pages/first-time-driver.jpg";
import ShellCard from "../../components/ShellCard.jsx";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FloridaDriverTestInPerson = () => {
  const locations = [
    {
      area: "HEADQUARTERS AIRPORT/DORAL AREA",
      address: "7500 N.W. 25th Street #119",
      city: "Miami, FL 33122",
    },
    {
      area: "WEST DADE/FIU AREA",
      address: "1321 SW 107 Ave #213A",
      city: "Miami, FL 33174",
    },
    {
      area: "Broward Road Test Location",
      address: "3726 W. Oakland Park Blvd",
      city: "Lauderdale Lakes, FL 33311",
    },
    {
      area: "CENTRAL PALM BEACH AREA",
      address: "1993 S. Military Trail",
      city: "West Palm Beach, FL 33415",
    },
  ];

  const registerLink = "https://classroom.metrotrafficschool.com/dmv-exam-register/MzQ=?_gl=1*lryg5y*_gcl_au*MTU2NDc3NDA3Ni4xNzYzNTY2ODcw";

  return (
    <>
      <section className="hero-slider-section">
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${heroBanner})`,
          }}
        >
          <div className="banner-text-container">
            <div className="banner-heading">
              <h1 className="banner-title">Florida Driver Test - In Person</h1>
              <p className="banner-subheading">Metro Traffic School</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row">
          <div className="col-12">
            <ShellCard>
              <div className="row">
                <div className="col-12 col-md-5 mb-4 mb-md-0">
                  <div className="text-start">
                    <img
                      src={permitImage}
                      alt="Florida Driver Test In Person"
                      className="img-fluid mb-4"
                      style={{ maxWidth: "100%" }}
                    />

                    <div className="mb-4">
                      <p className="mb-2" style={{ color: "#fff" }}>
                        If you have any questions, feel free to call us at <a href="tel:1-888-41-Metro" className="text-decoration-none fw-bold" style={{ color: "var(--metro-yellow)" }}>1-888-41-Metro</a>.
                      </p>
                      <p className="mb-4">
                        <a
                          href="/florida-driver-handbook"
                          className="text-decoration-none fw-bold text-warning"
                        >
                          Click here for the Driver's Handbook.
                        </a>
                      </p>
                    </div>

                    <div className="locations-list">
                      {locations.map((loc, index) => (
                        <div key={index} className="mb-4 p-3 rounded" style={{ backgroundColor: "#222", borderLeft: "4px solid var(--metro-yellow)" }}>
                          <h6 className="fw-bold mb-2" style={{ color: "var(--metro-yellow)", textTransform: "uppercase", fontSize: "0.9rem" }}>{loc.area}</h6>
                          <p className="mb-0" style={{ color: "#fff", fontSize: "0.95rem" }}>
                            {loc.address}<br />
                            {loc.city}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-7">
                  <div className="mb-5">
                    <h4 className="fw-bold mb-3" style={{ color: "var(--metro-yellow)" }}>
                      Book online and we will save your spot!
                    </h4>

                    <div className="mb-4">
                      <div className="fw-bold mb-3" style={{ color: "#fff" }}>
                        <FontAwesomeIcon icon={faUser} className="me-2" />
                        Walk-in's Welcome
                      </div>
                      <div className="d-flex flex-wrap justify-content-start">
                        <a
                          href={registerLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                          style={{ minWidth: "200px" }}
                        >
                          Register Now!
                        </a>
                      </div>
                    </div>

                    <div className="mb-4">
                      <p className="lh-lg" style={{ color: "#fff" }}>
                        Anyone, regardless of age is eligible to complete the Florida Permit Test (Class E Knowledge Exam) in person at one of our offices. It does not matter how old you are, or how, where, or with whom you completed the 4 hour first time driver drug and alcohol course.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h5 className="fw-bold mb-3" style={{ color: "var(--metro-yellow)" }}>
                        Benefits of taking the Florida Class E Knowledge Exam at our one of our offices:
                      </h5>
                      <ul className="mb-2 lh-lg" style={{ color: "#fff", listStyleType: "none", paddingLeft: 0 }}>
                        <li>– No need to go to a crowded DMV Office</li>
                        <li>– Instead take at one of our 3 convenient comfortable offices</li>
                        <li>– No need to make an appointment</li>
                        <li>– Just walk in</li>
                        <li>– Available in Spanish, English, Russian and Creole</li>
                        <li>– We automatically report to DMV so you would just need to go take your picture at the DMV</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <p className="lh-lg" style={{ color: "#fff" }}>
                        Our Florida Knowledge Exam is for those getting a learner permit or getting a Florida Driver’s License. The Florida Class E Knowledge Exam will consist of 50 questions that will cover:
                      </p>
                      <ul className="mb-2 lh-lg" style={{ color: "#fff", listStyleType: "none", paddingLeft: 0 }}>
                        <li>– Road Signs</li>
                        <li>– Road Rules</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-12 col-md-6">
                    <div className="">
                      <div
                        className="p-4 rounded mb-4 text-center"
                        style={{
                          backgroundColor: "#252525",
                          borderRadius: "8px",
                          border: "2px solid var(--metro-yellow)",
                        }}
                      >

                        <h3 className="text-white mb-3">Florida Permit Test In Person</h3>
                        <div className="mb-3">
                          <span
                            className="display-5 fw-bold"
                            style={{ color: "var(--metro-yellow)" }}
                          >
                            $80.00
                          </span>
                        </div>
                        <p className="text-white mb-3">No Wait time when booking online.</p>

                        <p className="mb-4 fst-italic" style={{ color: "#aaa", fontSize: "0.9rem" }}>
                          The fee for the proctored exam is $80.00. Also offered online for only $24.95, but must be under the age of 18 years old.
                        </p>
                        <div className="fw-bold mb-3" style={{ color: "#fff" }}>
                          <FontAwesomeIcon icon={faUser} className="me-2" />
                          Walk-in's Welcome
                        </div>
                        <div className="d-flex flex-wrap justify-content-center gap-3">
                          <a
                            href={registerLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-lg px-4 py-2 fw-bold text-dark metro-btn-primary text-decoration-none"
                            style={{ minWidth: "200px" }}
                          >
                            Register Now!
                          </a>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <p className="lh-lg" style={{ color: "#fff" }}>
                        Metro Traffic School is licensed by the Department of Highway Safety and Motor Vehicles (DHSMV) to offer the Class E Knowledge Exam online and in person.
                      </p>
                    </div>

                    <div className="mb-5">
                      <p className="fst-italic" style={{ color: "#aaa", fontSize: "14px" }}>
                        * All who complete the DMV Test, outside of the DMV office are subject to random re-examination.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ShellCard>
          </div>
        </div >
      </section >
    </>
  );
};

export default FloridaDriverTestInPerson;
